import { Component } from "react";
import RectButton from "../../components/ui/button/RectButton";
import TitleBar from "../../components/ui/TitleBar";
import AddCreditcardForm from "../../components/AddCreditcardForm";
import Lottie from 'react-lottie';
import * as paperPlaneData from '../../components/assets/json/lottie/paper-plane.json'
// import PaperAirplane from '../../components/assets/images/paper-airplane.svg';

import "./style.scss";

class PaymentMethods extends Component {
    render() {
        return (
            <>
                <div className="full-container payment-methods">
                    <section className="section-box methods">
                        <TitleBar title="My Payment Methods" />
                        <div className="box container">
                            <div className="method row lock">
                                <p>Visa  ••••  4723</p>
                                <RectButton text="REMOVE CARD" />
                            </div>
                            <div className="method row lock">
                                <p>Visa  ••••  4723</p>
                                <RectButton text="REMOVE CARD" />
                            </div>
                        </div>
                    </section>

                    <section className="section-box add-card">
                        <TitleBar title="Add a Card" />
                        <div className="box">
                            <div className="row">
                                <AddCreditcardForm />
                                <RectButton text="ADD CARD" />
                            </div>
                        </div>
                        <div className="paper-airplane">
                            <Lottie options={{
                                loop: false,
                                autoplay: true,
                                animationData: paperPlaneData.default,
                            }}
                                height="100%"
                                width="100%" />
                        </div>
                        {/* <div className="paper-airplane"><img src={PaperAirplane} alt="Paper Airplane" /></div> */}
                    </section>
                </div>
            </>
        )
    }
}

export default PaymentMethods;